export const authExcludedEndpoints: string[] = [
  'refreshAccessToken',
  'loginUserWithCredentials',
  'loginUserWithFunnelFox',
  'resetPassword',
  'forgotPassword',
  'loginWithAToken',
  'requestOtp',
  'loginUserWithOtp',
];

export const includeLocaleToEndpoints: string[] = [
  'refreshAccessToken',
  'loginUserWithCredentials',
  'loginUserWithFunnelFox',
  'loginWithAToken',
  'requestOtp',
  'loginUserWithOtp',
];
